/**
 * Utility function to send error notifications to Google Chat
 * @param {Error} error - The error object
 * @param {Object} errorInfo - React error info object
 * @param {string} webhookUrl - Google Chat webhook URL
 * @returns {Promise} - Promise that resolves when notification is sent
 */
import { axiosHelper } from '@root/services/axios';

export const sendErrorToGoogleChat = async error => {
  // if (!webhookUrl) {
  //   console.error('Google Chat webhook URL is not configured');
  //   return;
  // }
  // const tenantId = localStorage.getItem('tenantID');
  const tenantName = localStorage.getItem('tenantName');
  const email = JSON.parse(localStorage.getItem('User') ?? '{}')?.user?.email ?? '';

  try {
    // Get current URL and user agent
    const currentUrl = window.location.href;
    const userAgent = navigator.userAgent;

    // Format the error message
    // const errorMessage = {
    //   text: `🚨 *Application Error Detected*\n\n` +
    //     `*Tenant ID:* ${tenantId}\n` +
    //     `*Tenant Name:* ${tenantName}\n` +
    //     `*Email:* ${email}\n` +
    //     `*Error Message:* ${error.message}\n` +
    //     `*URL:* ${currentUrl}\n` +
    //     `*User Agent:* ${userAgent}\n` +
    //     `*Time:* ${new Date().toISOString()}\n\n` +
    //     `*Stack Trace:*\n\`\`\`\n${error.stack}\n\`\`\``
    // };

    const payload = {
      tenantName: tenantName,
      email: email,
      errorMessage: error.message,
      errorStack: error.stack,
      currentUrl: currentUrl,
      userAgent: userAgent,
    };

    // Send to Google Chat
    const response = await axiosHelper.axiosPost('alerts/application-errors', payload, true);

    console.log('error-response', response);

    if (!response.ok) {
      console.error('Failed to send error notification to Google Chat', response.statusText);
    }
  } catch (notificationError) {
    console.error('Error sending notification to Google Chat', notificationError);
  }
};
